export enum OrderStatus {
  'CONTRACT' = 'CONTRACT',
  'ACTIVE' = 'ACTIVE',
  'CANCELED' = 'CANCELED'
}
